/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
require('bootstrap-icons/font/bootstrap-icons.css');
require('./utils');

window.Vue = require('vue').default;
window.Swal = require('sweetalert2').default;
window.XLSX = require('xlsx');
window.moment = require('moment');
window.ApexCharts = require('apexcharts');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/* Login */
Vue.component('login-component', require('./components/login.vue').default);

/* Navbar */
Vue.component('navbar', require('./components/Navbar.vue').default);

/* Currency Input */
Vue.component('currency-input', require('./components/CurrencyInputComponent.vue').default);

/* Reports */
Vue.component('dashboard', require('./components/dashboard.vue').default);
Vue.component('reports', require('./components/reports/reports.vue').default);

/* Invoice */
Vue.component('invoice', require('./components/invoice/invoice.vue').default);
Vue.component('transactions', require('./components/invoice/transactions.vue').default);

/* Product */
Vue.component('product-component', require('./components/product/product.vue').default);

/* Permission */
Vue.component('role-permission', require('./components/permission/roleAndPermissions.vue').default);

/* User */
Vue.component('user-component', require('./components/user/userComponent.vue').default);
Vue.component('forgot-password-component', require('./components/user/forgotPassword.vue').default);

/* Spend */
Vue.component('spend-component', require('./components/spend/spendComponent.vue').default);

/* Opening */
Vue.component('cash-register', require('./components/cashRegister/cashregister.vue').default);
Vue.component('opening-component', require('./components/opening.vue').default);

/* Movement */
Vue.component('movement-component', require('./components/movement/movement.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
*/

const app = new Vue({
	el: '#app',
});

// Add user on vue prototype
// if(document.head.querySelector("[name=user][content]")){
//     Vue.prototype.$user     = JSON.parse(window.atob(document.head.querySelector("[name=user][content]").content));
// }

// Obtener el archivo JSON de idioma
// const getLanguageFile = async () => (await axios.get(`/language-json`)).data;

// Función para buscar y reemplazar las palabras en el documento
// const translateDocument = (language) => {
// 	// Obtener todas las etiquetas HTML que contengan texto
// 	const elements = document.getElementsByTagName('*');

// 	// Iterar por cada elemento y reemplazar el texto si se encuentra en el archivo de idioma
// 	for (let i = 0; i < elements.length; i++) {
// 		const element = elements[i];
// 		if (
// 			element.childNodes.length &&
// 			element.tagName.toLowerCase() !== "script"
// 		) {
// 			element.childNodes.forEach((child) => {
// 				if (child.nodeType === 3 && child.textContent.trim() !== "") {
// 					const translation = language[child.textContent.trim()];
// 					if (translation) {
// 						child.textContent = translation;
// 					}
// 				}
// 			});
// 		}
// 	}
// };

// Cargar el archivo de idioma y traducir el documento
// getLanguageFile().then(response => {
// 	window.lang = response;
// 	translateDocument(window.lang);
// });

